import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import ChartGraphArch from '../charts/ChartGraphArch';
import ChartFunnel from '../charts/ChartFunnel';
import { Brain, TrendingUp, Users, School } from 'lucide-react';

// 区块3：产品与技术方案
export default function Section03Product() {
  const features = [
    {
      icon: Brain,
      title: 'AI智能评价',
      desc: '基于NLP与OCR多模态分析，生成数学学科专属五维评分与改进建议。',
    },
    {
      icon: TrendingUp,
      title: '成长档案',
      desc: '构建大学四年连续成长曲线，支持聚类分析与个性化发展路径推荐。',
    },
    {
      icon: Users,
      title: '资源社区',
      desc: '汇聚精品微课片段，通过用户分群实现精准资源推送与同伴互评。',
    },
    {
      icon: School,
      title: '双师课堂',
      desc: '师范生与县域中学结对，构建"培养-实训-服务"的社会价值闭环。',
    },
  ];

  return (
    <SectionWrapper
      id="product"
      title="产品与技术方案"
      subtitle="五维AI评价 · 四年成长档案 · 双师课堂闭环——本项目以数据驱动重新定义师范生教学能力评价标准。"
    >
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        {/* 中央：技术架构图 */}
        <ScrollReveal className="lg:col-span-3">
          <div className="glass-card min-h-[520px]">
            <ChartGraphArch />
          </div>
        </ScrollReveal>

        {/* 右侧：漏斗图 */}
        <ScrollReveal delay={150} className="lg:col-span-2">
          <div className="glass-card min-h-[520px]">
            <ChartFunnel />
          </div>
        </ScrollReveal>
      </div>

      {/* 下方：4张功能卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <ScrollReveal key={index} delay={100 * index}>
              <div className="glass-card h-full">
                <Icon className="w-12 h-12 text-cyan mb-4" />
                <h4 className="text-2xl font-bold text-white mb-3">{feature.title}</h4>
                <p className="text-base text-slate-300 leading-relaxed">{feature.desc}</p>
              </div>
            </ScrollReveal>
          );
        })}
      </div>
    </SectionWrapper>
  );
}
